// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2pIbp","content":"Consent_content__2a5gs","footer":"Consent_footer__2DBa1"};